const IconCloseCircle = () => {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.5'
        d='M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z'
        stroke='#9298B4'
        strokeWidth='1.5'
      />
      <path
        d='M7.25001 4.75001L4.75001 7.25M4.75 4.75L7.25001 7.25'
        stroke='#9298B4'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default IconCloseCircle;
